 import * as React from "react"
 
 const PageHeading = ({children}) => {
   return (
     <h1 className="text-4xl font-bold mb-5">{children}</h1>
   )
 }
 
 export default PageHeading
 